'use client'

import { useTranslations } from 'next-intl'
import { Suspense, useState } from 'react'

import { THideSocials } from '@/utils'

import { CancelSubscriptionSuccessDialog } from '../LandingPage/LandingDialogs/CancelSubscriptionSuccessDialog'
import { CancelSubscriptionCard } from './components/CancelSubscriptionCard'
import { CancelSubscriptionConfirmDialog } from './components/CancelSubscriptionConfirmDialog'
import { CancelSubscriptionSourceListener } from './components/CancelSubscriptionSourceListener'

type TCancelSubscriptionContainerProps = {
	hideSocials: THideSocials
}

export const CancelSubscriptionContainer = ({
	hideSocials,
}: TCancelSubscriptionContainerProps) => {
	const t = useTranslations()
	const [source, setSource] = useState<string | undefined>(undefined)

	const [cancelRequestId, setCancelRequestId] = useState<string | null>(null)
	const [isSuccess, setIsSuccess] = useState<boolean>(false)

	return (
		<div className="flex justify-center bg-generator-bg px-3 mobile:px-5 desktop:px-0">
			<Suspense fallback={null}>
				<CancelSubscriptionSourceListener onSourceChange={setSource} />
			</Suspense>
			<CancelSubscriptionCard
				hideSocials={hideSocials}
				onCancelRequestCreated={setCancelRequestId}
				source={source}
			/>
			<CancelSubscriptionConfirmDialog
				cancelRequestId={cancelRequestId}
				onOpenChange={(open) => {
					if (!open) {
						setCancelRequestId(null)
					}
				}}
				onSuccess={() => {
					setCancelRequestId(null)
					setIsSuccess(true)
				}}
			/>
			<CancelSubscriptionSuccessDialog
				isOpen={isSuccess}
				onClose={() => setIsSuccess(false)}
				translations={{
					closeButtonLabel: t('ui__popup__close_button'),
					title: t('public__cancel_subscription__modal_title'),
					description: t(
						'public__cancel_subscription__modal_description',
					),
					submit: t('public__cancel_subscription__modal_button'),
				}}
			/>
		</div>
	)
}
